﻿require('./app.styles');

import { ShareBaseModule} from 'sharebase/sharebase';
import { FeatureHighlightSlidesController } from 'sharebase-app/components/slides';
import { 
	CommonUtilsService,
	ObjectHandleRepository 
} from 'util/util';
import { 
	StaticToggleService, 
	StorageToggleService 
} from 'util/services'
import { DocumentAction } from 'sharebase-app/components/documentView/documentView.actions';
import { AppAction } from 'sharebase-app/components/_app/app.actions';
import { ToolbarService } from 'sharebase-app/services/appToolBarService';
import { TrackingService } from 'sharebase/services/trackingService';
import { FullTextSearchDataStore } from "sharebase/dataStores/fullTextSearchDataStore";
import { 
	ActionService,
	AuthService,
	PhoenixToggleService,
	ProgressService,
	EnvironmentService,
	LocalizedResourcesService
} from 'phoenix/services';
import { DocumentDataStore } from 'sharebase-app/dataStores/documentDataStore';
import { FolderDataStore } from 'sharebase-app/dataStores/folderDataStore';
import { SelectionDataStore } from 'sharebase-app/dataStores/selectionDataStore';
import { 
	ISurveyRequestService, 
	UserStats 
} from 'sharebase/components/surveyRequest/surveyRequest.service';
import { IStateHistoryService } from 'util/services';
import { LogoutDialogService } from 'sharebase-app/services/logoutDialogService/logoutDialogService';
import { 
	ShareBaseAction,
	IMenuItem
} from 'sharebase/domain';
import { ShareBaseFolder } from 'phoenix/domain';
import { 
	AnalyticsMenuItemFactory,
	PermissionRequestPayload 
} from 'sharebase-app/domain';
import { 
	Helpers as AppHelpers, 
	default as helpersModule
} from 'sharebase-app/components/_app/helpers';
import {
	IDesktopService,
	DownloadService,
	ThemingService,
	ToastService
} from 'sharebase/services';
import { 
	PendingActionsService,
	PendingActionScope
} from 'sharebase/services/pendingActionsService';
import { LearnMoreDialogController} from 'sharebase-app/components/learnMoreDialog/learnMoreDialog'
import { RequestPermissionsDialog } from 'sharebase-app/components/requestPermissionsDialog/requestPermissionsDialog';
import { NotificationDataStore } from 'sharebase-app/dataStores/notificationDataStore';
import { UploadProgressDataStore } from 'sharebase-app/dataStores/uploadProgressDataStore';
import { DeferredPermissionMenuItemFactory } from 'sharebase-app/factories/deferredpermissionMenuItemFactory';
import { FullTextUIService } from 'sharebase-app/services/fullTextService'
import { OnlineUsersService } from 'real-time'
import { TasksDataStore } from 'sharebase-app/dataStores/tasksDataStore';
import { ConfirmDialog } from 'sharebase/components/confirmDialog/confirmDialog';
import { DownloadDesktopDialog } from 'sharebase/components/downloadDesktopDialog/downloadDesktopDialog';
import { DetailsPanelService } from 'sharebase-app/services/detailsPanelService';
import { MenuItemFactory } from 'sharebase/factories';

const learnMoreTemplate = require('../learnMoreDialog/learnMoreDialog.template');
const breadcrumbsTemplate = require('./breadcrumbs.template');

function buildLoginRedirectPath(toState, toParams): string {
	let redirectPath = '/';
	if (toState.url) {
		redirectPath = Object.keys(toParams)
			.reduce((path: string, key: string) => {
				let urlParam = `:${key}`;
				let keyIndex = path.indexOf(urlParam);
				if (keyIndex >= 0) {
					path = path.replace(urlParam, toParams[key]);
				}

				return path;
			}, toState.url);
	}

	// All paths are expected to be absolute, so normalize the path before returning
	if (redirectPath.charAt(0) !== '/') {
		redirectPath = `/${redirectPath}`;
	}

	return redirectPath;		
}

export const appAppModule = angular.module('sharebase-app.app', [
	'ui.router',
	'gettext',
	ShareBaseModule.name,
	helpersModule.name
])
// we want to treat this like an Angular constant, but constants can't have dependencies and aren't dyanmic
.factory('SBA_GET_REQUEST_RIGHTS_ENABLED', [
	'staticToggleService',
	'pxAuthService', 
	(staticToggleService:StaticToggleService, pxAuthService:AuthService) => {
		return () => staticToggleService.isEnabled('request-rights') && !pxAuthService.isShareByLinkUser
	}
])
.config([
	'$stateProvider',
	'$urlRouterProvider',
	'$httpProvider',
	'pxDisplayMessageServiceProvider',
	function (
		$stateProvider,
		$urlRouterProvider,
		$httpProvider,
		pxDisplayMessageServiceProvider
	) {
		// Globally disable request caching for IE
		if (navigator.userAgent.indexOf('Trident') > -1) {
			$httpProvider.defaults.headers.get = $httpProvider.defaults.headers.get || { };
			$httpProvider.defaults.headers.get['If-Modified-Since'] = 'Sat, 01 Jan 2000 00:00:00 GMT';
			$httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
		}
		
		var displayMessageState = 'content.displayMessage';
		// Set the correct state for the display message state for redirecting to the homepage.
		pxDisplayMessageServiceProvider.setHomeState('content.myFiles.home');
		pxDisplayMessageServiceProvider.setDisplayMessageState(displayMessageState);

		$stateProvider
			.state('content.myFiles', {
				abstract: true,
				url: '',
				views: {
					'homeContent': { template: '<sba-my-files flex></sba-my-files>'} 
				}
			})
			.state('content.favorites', {
				url: 'favorites',
				data: {
					isTopLevel: true
				},
				views: {
					'homeContent': { template: '<sba-folder-view folder-id="favorites" flex />' },
					'homeDetails': { template: '<sba-empty-details flex />' }
				}
			})
			.state('content.shared', {
				abstract: true,
				url: 'shared-items',
				views: {
					'homeContent': { template: '<sba-shared-files flex />' }
				}
			})
			.state('content.deleted', {
				url: 'deleted-items',
				data: {
					isTopLevel: true
				},
				views: {
					'homeContent': { template: '<sba-deleted-items flex />' },
					'homeDetails': { template: '<sba-empty-details flex />' }
				}
			})
			.state('content.recent', {
				url: 'recent-items',
				data: {
					isTopLevel: true
				},
				views: {
					'homeContent': { template: '<sba-folder-view folder-id="recents" flex />' },
					'homeDetails': { template: '<sba-empty-details flex />' }
				}
			})
			.state('content.notifications', {
				url: 'notifications',
				data: {
					isTopLevel: true
				},
				resolve: {
					promiseObj: [
						'$stateParams',
						'sbaViewItemIndexDataStore',
						function ($stateParams, sbaViewItemIndexDataStore) {
							//get index
							var path = '/notifications';
							//get index
							$stateParams.itemIndex = sbaViewItemIndexDataStore.urlIndex(path);
							//clear index
							sbaViewItemIndexDataStore.remove(path);
							return;
					}]
				},
				views:{
					'homeContent': {
						template: function (params) {
							return '<sba-notifications flex item-index="' + params.itemIndex + '"></sba-notifications>';
						}
					},
					'homeDetails': { template: '<sba-empty-details flex />' }
				},
				onExit: [
					'$location',
					'sbaViewItemIndexDataStore',
					function ($location, sbaViewItemIndexDataStore) {
						var index = angular.element(document.querySelector('sba-notifications')).attr('item-index');
						sbaViewItemIndexDataStore.add($location.path(), index);
					}
				]
			})
			.state(displayMessageState, {
				url: 'displaymessage',
				data: {
					// this route can be accessed with a share-by-link token
					allowUnauthenticatedAccess: true,
					shareView: true
				},		
				params: {
					header: '',
					message: ''
				},
				views: {
					'homeContent': {
						template: function(params) {
							return '<px-display-message header="' + params.header + '" message="' + params.message + '"></px-display-message>';
						}
					}
				}
			})
			.state('content.fulltextsearch', {
				url: 'search/',
				params: {
					phrase: ''
				},
				resolve: {
					promiseObj: [
						'$stateParams',
						'sbaViewItemIndexDataStore',
						'sbFullTextDataStore',
						function ($stateParams, sbaViewItemIndexDataStore, sbFullTextDataStore: FullTextSearchDataStore) {									
							//get index
							var path = '/search/' + $stateParams.phrase;
							//get index
							$stateParams.itemIndex = sbaViewItemIndexDataStore.urlIndex(path);
							//clear index
							sbaViewItemIndexDataStore.remove(path);	
					}]
				},
				views: {
					'homeContent': {
						template: params => {									
							//use full text search
							
							return '<sba-full-text-search-results></sba-full-text-search-results>';
						}
					},
					'homeDetails': { template: '<sba-empty-details flex />' }
				},
				onExit: [
					'$location',
					'sbaViewItemIndexDataStore',
					'sbaFullTextUIService',
					function ($location, sbaViewItemIndexDataStore, sbaFullTextUIService:FullTextUIService) {
						var index = angular.element(document.querySelector('sba-content-search-results')).attr('item-index');
						sbaViewItemIndexDataStore.add($location.path(), index);

						sbaFullTextUIService.inFocus = false;
						sbaFullTextUIService.phrase = '';						
						sbaFullTextUIService.filters = [];
					}]
			})
			.state('content.tasks', {
				url: 'tasks',
				data: {
					rule: ['$state','pxPhoenixToggleService', ($state, pxPhoenixToggleService:PhoenixToggleService) => {
						return pxPhoenixToggleService.isEnabled('Platform/Tasks')
							.then(isEnabled=> {
								if(!isEnabled) {
									return {
										to: $state.current ? $state.current.name : 'content.myfiles.home'
									};
								}
							});
					}]
				},
				resolve: {
					promiseObj: [
						'$stateParams',
						'sbaViewItemIndexDataStore',
						function ($stateParams, sbaViewItemIndexDataStore) {
							let path = '/tasks';
							$stateParams.itemIndex = sbaViewItemIndexDataStore.urlIndex(path);
							sbaViewItemIndexDataStore.remove(path);
							return;
					}]
				},
				views:{
					'homeContent@content': {
						template: function (params) {
							return '<sba-tasks flex item-index="' + params.itemIndex + '"></sba-tasks>';
						}
					},
					'homeDetails@content': { template: '<sba-empty-details flex />' }
				},
				onEnter: [
					'sbaDetailsPanelService',
					function (sbaDetailsPanelSerice) {
						sbaDetailsPanelSerice.close();
					}
				],
				onExit: [
					'$location',
					'sbaViewItemIndexDataStore',
					function ($location, sbaViewItemIndexDataStore) {
						var index = angular.element(document.querySelector('sba-tasks')).attr('item-index');
						sbaViewItemIndexDataStore.add($location.path(), index);
					}
				]
			});
	}])
.run([
	'$location',
	'$rootScope', 
	'$state', 
	'$stateParams',
	'$injector',
	'$q',
	'$mdBottomSheet',
	'$mdDialog',
	'utils',
	'objectHandleRepository',
	'stateHistoryService',
	'pxAuthService',
	'sbAclDatastore',
	'sbPendingActionsService',
	'sbConfirmDialog',
	'sbTrackingService',
	'sbaToolbarService',
	'sbaFolderDataStore',
	'sbaDocumentDataStore',
	'sbaTasksDataStore',
	'pxEnvironmentService',
	'gettextCatalog',
	function (
		$location,
		$rootScope, 
		$state, 
		$stateParams, 
		$injector, 
		$q,
		$mdBottomSheet, 
		$mdDialog, 
		utils:CommonUtilsService,
		objectHandleRepo:ObjectHandleRepository,
		stateHistoryService:IStateHistoryService, 
		pxAuthService:AuthService, 
		sbAclDatastore,
		sbPendingActionsService:PendingActionsService,
		sbConfirmDialog:ConfirmDialog,
		sbTrackingService:TrackingService,
		sbaToolbarService:ToolbarService,
		sbaFolderDatastore:FolderDataStore,
		sbaDocumentDataStore:DocumentDataStore,
		sbaTasksDataStore:TasksDataStore,
		pxEnvironmentService,
		gettextCatalog:ng.gettext.gettextCatalog
	) {			
		let _forceState = false;

		$rootScope.$on('$stateChangeStart',  (e, to, toParams, from, fromParams) => {			
			if(sbPendingActionsService.unsavedChanges){
				let msg = sbPendingActionsService.getMessageBy(PendingActionScope.StateChange);
				let title = gettextCatalog.getString('Navigate');
				if(msg){
					e.preventDefault();
					sbConfirmDialog.open(e, msg, title).then((confirmed:boolean) => {
						if(confirmed){
							sbPendingActionsService.clearBy(PendingActionScope.StateChange);
							$state.go(to.name, toParams);
						}
					});
				}
			}
		});

		$rootScope.$on('$stateChangeStart', (e, to, toParams, from, fromParams) => {
			// prevent XSS for user-provided params by encoding them
			Object.keys(toParams)
				.filter(k => angular.isString(toParams[k]))
				.forEach(k => {
					toParams[k] = utils.htmlEncode(utils.interpolationEscape(toParams[k]));
				});
		});

		$rootScope.$on('$stateChangeStart', function (e, to, toParams, fromState, fromParams) {
			// handle back button when dialog is open
			if(angular.element(document.body).hasClass('md-dialog-is-showing')){
				$mdDialog.cancel();
			}
			
			// handle back button when bottom sheet is open
			if(angular.element(document.body).find('md-bottom-sheet').length > 0) {
				$mdBottomSheet.hide();
				e.preventDefault();
				return;
			}
			var rule = to.data ? to.data.rule : null;
			var allowUnauthenticatedAccess = to.data && angular.isDefined(to.data.allowUnauthenticatedAccess) ? 
				to.data.allowUnauthenticatedAccess : 
				false;
			var isShareView = to.data && angular.isDefined(to.data.shareView) ?
				to.data.shareView :
				false;
			var redirectPromise;
			
			// a previous, approved redirect was specified; abort any additional behavior here
			if(_forceState){ 
				_forceState = false;
				return;
			}

			// remove in memory share by link token if not targeting a share view
			if (pxAuthService.isShareByLinkUser && !isShareView) {
				pxAuthService.invalidateLogin(true);
			}

			if (!allowUnauthenticatedAccess && !pxAuthService.isAuthenticated && to.name !== 'login' && to.parent !== 'loginComponent') {
				let redirectOnLogin = {
					route: to,
					params: toParams
				}

				// don't redirect to the display message view on login, otherwise redirect to current URL
				pxAuthService.redirectPath = to.name === 'content.displayMessage' ? buildLoginRedirectPath(fromState, fromParams) : $location.path();
				
				redirectPromise = $q.resolve({
					to: 'login'
				});
			} else if (angular.isFunction(rule) || angular.isArray(rule)) {
				// add the toParams to the current state otherwise the $stateParams won't be available to rules
				$stateParams.toState = toParams;
				redirectPromise = $q.resolve($injector.invoke(rule));
			} else if(fromState.name === 'content.displayMessage' && (stateHistoryService.previous && to.name === stateHistoryService.previous.name)) {
				let state = stateHistoryService.goBack(2);
				if(state){
					redirectPromise = $q.resolve({
						to: state.name,
						params: state.params
					});
				}
			}

			if(redirectPromise){		
				e.preventDefault();	
				_forceState = true;
				
				redirectPromise
					.then(function(redirect){
						if (redirect) {
							$state.go(redirect.to, redirect.params, { reload: redirect.to === $state.current.name });
						} else {	
							$state.go(to.name, toParams);
						}
					})
					.catch(function(){
						$state.go('login');
					});
			}
		});

		$rootScope.$on('$stateChangeStart',  (e, to, toParams, from, fromParams) => {
			if(to.data && to.data.isEmailReferral) {
				e.preventDefault();
				sbTrackingService.addCustomDimension('Email Referral', true);
				$state.go(to.parent, toParams);
			}
		});

		$rootScope.$on('$stateChangeSuccess', function(e, to, toParams, fromState, fromParams){
			stateHistoryService.push({
				name: to.name,
				url: to.url,
				params: toParams
			}, to.name !== 'content.displayMessage');

			//remove registered views
			sbaToolbarService.clearViews();

			sbaToolbarService.actionTarget = null;
			sbAclDatastore.clearCache();
			sbaDocumentDataStore.clearStore();
			sbaFolderDatastore.clearStore();
			sbaTasksDataStore.clearHistoricalTasks();
			objectHandleRepo.revokeAll();
		});
	}
])
.directive('sbaApp', AppDirective);

const template = require('./app.template');
function AppDirective(
	$animate, 
	$interval, 
	$window, 
	$q, 
	$mdMedia, 
	$timeout,
	$state,
	sbaSelectionDataStore:SelectionDataStore,
	sbaLibraryDataStore, 
	sbaFolderDataStore,
	sbaNotificationDataStore:NotificationDataStore,
	pxAuthService:AuthService,
	pxActionService:ActionService,
	sbrtsOnlineUsersService:OnlineUsersService,
	sbaDetailsPanelService:DetailsPanelService
) {
	return {
		restrict: 'E',
		controller: AppController,
		controllerAs: 'sbAppCtrl',
		template,
		bindToController: {},
		scope: {},
		link: function (scope, element, attrs) {
			function getUnreadCount() {
				return sbaNotificationDataStore
					.loadUnread()
					.then(unread => {		
						scope.sbAppCtrl.setBadgeAndTab(unread.length);
					});
			}
			
			let pingNotesInterval = null;
			if(!pxAuthService.isShareByLinkUser) {
				getUnreadCount();
				pingNotesInterval = $interval(getUnreadCount, 30000);

				//add user to the deployment online users room				
				sbrtsOnlineUsersService.joinRoom(pxAuthService.deploymentId);
			}

			setActiveTopRoute($state.current);
			scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
				setActiveTopRoute(toState);				

				//clear any item selection
				sbaSelectionDataStore.clearSelection();
			});
							
			function setActiveTopRoute(toState){
				//hightlight the active nav item
				var stateOps = toState.name.split('.');
				if (stateOps.length === 1) {
					scope.sbAppCtrl.activeTopRoute = toState;
					return;
				}
				scope.sbAppCtrl.activeTopRoute = stateOps[0] + '.' + stateOps[1];
			}				
			
			//add event listener to adjust the state of the sideNavs
			var sidePanelTimout;
			function setSidePanels() {
				$timeout.cancel(sidePanelTimout);

				sidePanelTimout = $timeout(function () {
					// update right nav state
					sbaDetailsPanelService.updateStateCallback();

					if (scope.sbAppCtrl.leftNavOpen && $mdMedia('gt-sm')) {
						//close flyout panel
						scope.sbAppCtrl.leftNavOpen = false;
					}
				}, 150);
			}
			$window.addEventListener('orientationchange', setSidePanels);
			$window.addEventListener('resize', setSidePanels);
			$window.addEventListener('beforeunload', e => {
				if (scope.sbAppCtrl.sbPendingActionsService.unsavedChanges) {
					e.returnValue = scope.sbAppCtrl.sbPendingActionsService.message;
					return e.returnValue;
				}
			});

			function disableDrag(e) {				
				element.addClass('sba---is-dragging');
				if (!angular.element(e.target).hasClass('sba-drop-upload-target')) {
					e.preventDefault();
					try {
						// Bug in IE 11 that causes accessing `effectAllowed` to throw
						// using try block instead of checking if IE so if/when bug gets
						// the intended behavior will work in IE without us having to change this.
						e.dataTransfer.effectAllowed = "none";
					} catch (e) { }
					e.dataTransfer.dropEffect = "none";

					// After some discussion, it was decided that this is the best
					// approach to take to achieve the desired effect. As it stands
					// right now, dragging an item to the page will trigger the app
					// to display the drag n drop indicator. Logically, we want that
					// indicator to disappear when the user drops the file. In most
					// normal cases this is fine, but it is possible for the user to
					// attempt to drop an item on an area that isn't a drop zone (e.g. a library).
					// In that case, there is no drop event, so we need some other way
					// to know when the user is done with a drag n drop operation. That
					// is where this mouse event handler comes in. It only gets registered
					// when a drag n drop operation starts, during that operation all
					// mouse events are suspended until it completes. On the first mouse move
					// we hide the indicator and clear the event handler.
					let doc = angular.element(document);
					let mouseMove;
					mouseMove = (e) => {
						// Don't need to check for buttons because all mouse events are suspended until
						// drag n drop operation completes
						cleanupDrag();
						doc.off('mousemove', mouseMove);
					};
					doc.on('mousemove', mouseMove);
				} 
			}
			function cleanupDrag(){
				element.removeClass('sba---is-dragging');
				angular.element(document.querySelectorAll('.sba-drop-upload-target---active')).removeClass('sba-drop-upload-target---active');
				angular.element(document.querySelectorAll('.sba-dragging-inside')).removeClass('sba-dragging-inside');
			}

			pxActionService.subscribe(AppAction.EndDrag, cleanupDrag);
			
			$window.addEventListener('dragstart', disableDrag, false);
			$window.addEventListener("dragenter", disableDrag, false);
			$window.addEventListener("dragend", cleanupDrag, false);
			$window.addEventListener("dragover", disableDrag);
			$window.addEventListener("dragleave", disableDrag, true);
			$window.addEventListener("drop", disableDrag);

			scope.$on('$destroy', function () {
				//stop the notification polling
				$interval.cancel(pingNotesInterval);
				//remove events
				$window.removeEventListener('orientationchange', setSidePanels);
				$window.removeEventListener('resize', setSidePanels);

				$window.removeEventListener('dragstart', disableDrag);
				$window.removeEventListener("dragenter", disableDrag);
				$window.removeEventListener("dragend", cleanupDrag);
				$window.removeEventListener("dragover", disableDrag);
				$window.removeEventListener("dragleave", disableDrag);
				$window.removeEventListener("drop", disableDrag);					

				let uploadSvc = scope.sbAppCtrl.pxUploadProgressDS as UploadProgressDataStore;
				if (uploadSvc) {
					uploadSvc.dispose();
				}

				if(!pxAuthService.isShareByLinkUser) {
					//remove user to the deployment online users room				
					sbrtsOnlineUsersService.leaveRoom();
				}
				
			});
		}
	};
}

AppDirective.$inject =  [
	'$animate',
	'$interval',
	'$window',
	'$q',
	'$mdMedia',
	'$timeout',
	'$state',
	'sbaSelectionDataStore',
	'sbaLibraryDataStore',
	'sbaFolderDataStore',
	'sbaNotificationDataStore',
	'pxAuthService',
	'pxActionService',
	'sbrtsOnlineUsersService',
	'sbaDetailsPanelService'
];

const QUICK_NOTIFY_COUNT = 7;

class AppController {
	public desktopDownloadUrl:string;
	public downloadDesktopAvailable = false;
	public fullTextEnabled = false;
	public leftNavOpen = false;
	public loadingUIMetadata = true;
	public mobileSearchEnabled = false;
	public navItemTransition = false;
	public openAssignedTasksCount = 0;
	public rightNavOpen = false;
	public rightNavOpenInline = false;
	public searchInFocus = false;
	public showAllToolbarItems:boolean;
	public userTasksEnabled = false;

	public get isPollingForDesktop() {
		return this.sbDesktopService.polling;
	}

	public get isSharedContent() {
		return this.sbaFolderDataStore.isSharedContent || this.sbaDocumentDataStore.isSharedContent;
	}

	public static $inject = [
		'helpers',
		'SBA_TOOLTIP_DELAY',
		'$window',
		'$scope',
		'$timeout',
		'$location',			
		'$mdDialog',
		'$mdPanel',
		'$mdMedia',
		'$state',
		'$q',
		'pxAuthService',
		'pxProgressService',
		'sbBadgeCountFilter',
		'sbPendingActionsService',
		'sbToastService',
		'sbDesktopService',
		'sbDownloadDesktopDialog',
		'sbDownloadService',
		'sbTrackingService',
		'sbaDetailsPanelService',
		'sbaNotificationDataStore',
		'sbaSelectionDataStore',
		'sbaToolbarService',
		'sbaViewItemIndexDataStore',
		'sbaFullTextUIService',
		'sbaTasksDataStore',
		'localStorageService',
		'settingsService',
		'pxEnvironmentService',
		'pxLocalizedResourcesService',
		'sbaDocumentDataStore',
		'sbaFolderDataStore',
		'pxActionService',
		'pxUploadProgressDataStore',
		'staticToggleService',
		'pxPhoenixToggleService',
		'sbSurveyRequestService',
		'sbaLogoutDialogService',
		'sbaRequestPermissionsDialog',
		'sbaFeatureHighlightSlides',
		'sbThemingService',
		'sbrtsOnlineUsersService',
		'gettextCatalog'
	];

	public constructor(
		helpers:AppHelpers,
		public readonly tooltipDelay:number,
		private readonly $window:ng.IWindowService,
		private readonly $scope:ng.IScope,
		private readonly $timeout:ng.ITimeoutService,
		public readonly currentLocation,
		private readonly $mdDialog:ng.material.IDialogService,
		private readonly $mdPanel:ng.material.IPanelService,
		private readonly $mdMedia:ng.material.IMedia,
		public readonly state:ng.ui.IStateService,
		$q:ng.IQService,
		public readonly authService:AuthService,
		private readonly pxProgressService:ProgressService,
		public readonly sbBadgeCountFilter,
		private readonly sbPendingActionsService:PendingActionsService,
		private readonly sbToastService:ToastService,
		private readonly sbDesktopService:IDesktopService,
		private readonly sbDownloadDesktopDialog:DownloadDesktopDialog,
		private readonly sbDownloadService:DownloadService,
		private readonly sbTrackingService:TrackingService,
		public readonly sbaDetailsPanelService:DetailsPanelService,
		public readonly notificationDS:NotificationDataStore,
		public readonly selectionDS: SelectionDataStore,
		public readonly sbaToolbarService:ToolbarService,
		private readonly sbaViewItemIndexDataStore,
		public readonly sbaFullTextUIService:FullTextUIService,
		public readonly sbaTasksDataStore:TasksDataStore,
		private readonly localStorageService,
		public readonly settings,
		public readonly pxEnvironment:EnvironmentService,
		public readonly resourcePaths:LocalizedResourcesService,
		public readonly sbaDocumentDataStore:DocumentDataStore,
		public readonly sbaFolderDataStore,
		private readonly pxActionService:ActionService,
		public readonly pxUploadProgressDS:UploadProgressDataStore, 
		staticToggleService:StaticToggleService,
		pxPhoenixToggleService:PhoenixToggleService,
		sbSurveyRequestService:ISurveyRequestService, 
		private readonly sbaLogoutDialogService:LogoutDialogService,
		sbaRequestPermissionsDialog:RequestPermissionsDialog,
		public readonly featureSlides:FeatureHighlightSlidesController,
		public readonly sbThemingService:ThemingService,
		public readonly onlineUsers:OnlineUsersService,
		private readonly gettextCatalog:ng.gettext.gettextCatalog
	) {
		if (this.authService.isAuthenticated) {
			// If `.show` is not called in a timeout callback, the backdrop does not span the full height of the screen.
			$timeout(() => {
				if (this.authService.userStatistics.LoginsByUser.Count > 1){
					let title = gettextCatalog.getString("Feedback");
					let message = gettextCatalog.getString('We value your opinion and we are constantly working to improve ShareBase. Please tell us what you think.  Thanks!');
					let url= 'https://www.surveygizmo.com/s3/4499113/sbfeedback?admin='+ this.authService.isSiteAdmin +'&deploymentid=' + this.authService.deploymentId;
					let baseStats=[{stat:UserStats.Logins,value:100}];
						
					sbSurveyRequestService.show(title, message, url, baseStats)
						.then(response => {
							//we don't want to show the survey at the same time as the feature highlight slides
							if(!response) {
								featureSlides.show();
							}
						});
				}
			}, 2000);
		}
		this.showAllToolbarItems = !staticToggleService.isEnabled('minimized-action-bar');
		
		//Perform the async operations that are needed to determine how the UI appears to the user (theme colors, toggleable UI elements, etc.)
		this.pxProgressService.backdrop = this.pxProgressService.visible = this.loadingUIMetadata;
		$q.all([
			sbThemingService.applyBrandedTheme(),
			pxPhoenixToggleService.isEnabled('Platform/Tasks'),
			pxPhoenixToggleService.isEnabled('Core/Full-Text-Search')
		])
		.then(uiDetailsResults => {
			this.userTasksEnabled = uiDetailsResults[1]; 
			this.fullTextEnabled = uiDetailsResults[2];

			if(this.userTasksEnabled) {
				sbaTasksDataStore.loadOpenTasksAssignedToMe();
			}
		})
		.catch(() => {
			console.error('An error occurred when attempting to retrieve UI details.');
		})
		.finally(() => {
			this.loadingUIMetadata = false;
			this.pxProgressService.backdrop = this.pxProgressService.visible = this.loadingUIMetadata;
		});

		this.rightNavOpenInline = localStorageService.getStoredValue('sba-right-nav-inline-open') === 'true' ? true : false;

		// add custom tracking dimensions
		sbTrackingService.addCustomDimension('Data Center Name',this.currentLocation.host());
		sbTrackingService.addCustomDimension('Deployment Name', authService.systemName);
		sbTrackingService.addCustomDimension('Deployment ID', authService.deploymentId.toString());	
		sbTrackingService.addCustomDimension('Deployment Site Admin', authService.isSiteAdmin);	
		sbTrackingService.addCustomDimension('Deployment User Admin', authService.isUserAdmin);
		sbTrackingService.addCustomDimension('User Type', authService.isShareByLinkUser ? 'External' : 'Internal');

		// initialize progress data store to start listening for new upload events.
		this.pxUploadProgressDS.init();		
		helpers.registerActions();
		helpers.registerMenuItems();

		pxActionService.subscribe<PermissionRequestPayload>(ShareBaseAction.RequestRight, (request, event) => {
			sbaRequestPermissionsDialog.open(event, request.item, request.permission, request.targetAction);
		});

		pxActionService.subscribe<ShareBaseFolder>(DocumentAction.DeleteSuccess, (f) => this.documentDeleteHandler(f));
		pxActionService.subscribe<ng.IAngularEvent>(AppAction.PromptForDesktopInstall, (e) => this.promptDesktopDownload(e));

		if (!this.authService.isShareByLinkUser) {
			this.authService.getUserStatistics();
			sbDesktopService
				.discover()
				.catch(() =>{
					this.downloadDesktopAvailable = true;
					var msg = gettextCatalog.getString('ShareBase Desktop was not found. Certain features will be disabled.');				
					sbToastService.showSimple(msg);

					//get path to download
					if(this.pxEnvironment.isWindows){
						sbDesktopService.getDownloadUrl()
							.then((url:string) => {
								this.desktopDownloadUrl = url;
							});
					}
				});
		}
	}
	
	public breadcrumbs() {
		var bread = [];
		if(this.state.current.name.indexOf('.folder') > -1){
			bread = this.sbaFolderDataStore.breadcrumbs;
		}
		else if(this.state.current.name.indexOf('.document') > -1){
			bread = this.sbaDocumentDataStore.breadcrumbs;
		}

		if(!bread) {
			return bread;
		}
		
		return bread.map((item) => {
			if(item.LibraryName && item.LibraryName === 'My Library') {
				item.LibraryName = this.gettextCatalog.getString('My Files');
			}

			return item;
		});
	}

	public changeSort(sort, ev) {
		this.sbaToolbarService.setSortType(sort);
		this.pxActionService.emit({
			type: AppAction.SortChange, 
			payload: this.sbaToolbarService.sortType
		}, ev);
	}

	public closeMobileSearch() {
		this.mobileSearchEnabled = false;
	}

	public getBreadcrumbName(index:number) {
		let breadcrumbAtIndex = this.breadcrumbs()[index];

		if(breadcrumbAtIndex.FolderId) {
			return breadcrumbAtIndex.FolderName;
		}
		else {
			return breadcrumbAtIndex.LibraryName;
		}
	}

	public goBack() {
		this.$window.history.back();
	}

	public downloadDesktop() {
		this.sbTrackingService.trackClick('Desktop Download link clicked - Sidenav');
		if (this.desktopDownloadUrl) {
			this.sbDownloadService.downloadByUri(this.desktopDownloadUrl);
		}
		else {
			this.sbToastService.showSimple(this.gettextCatalog.getString('There was a problem with downloading ShareBase Desktop.'));
		}
	}

	public goHomeOrNoOp() {
		if(!this.authService.isShareByLinkUser) {
			this.state.go('content.myFiles.home');
		}
	}

	public learnMore(ev){
		this.$mdDialog.show({
			controller: LearnMoreDialogController,
			controllerAs: 'vm',
			template: learnMoreTemplate,
			targetEvent: ev,
			locals:{ context: 'app', state: this.state.current},
			fullscreen: this.$mdMedia('sm') || this.$mdMedia('xs'),
			clickOutsideToClose:true
		});
	}

	public navItemClicked() {
		this.navItemTransition = true;
		//clear all save view item indexes
		this.$timeout(() => {
			//we have to wait until the onExit state logic runs
			this.sbaViewItemIndexDataStore.clearAll();
			this.navItemTransition = false;
		}, 500);

		if (this.$mdMedia('gt-sm')) {
			return;
		}
		//close the side nav on location change
		this.leftNavOpen = false;
	}

	public openBreadcrumb(crumb) {
		if(crumb.FolderId){
			//just a folder
			if(this.state.current.name === 'content.myFiles.folder.share' || this.state.current.name === 'content.myFiles.document.share'){
				//shared by link		
				this.state.go('content.myFiles.folder.share',{folderID: crumb.FolderId});
			}
			else if(this.state.current.name.indexOf('content.shared.') > -1){
				//user/group share
				this.state.go('content.shared.folder',{folderID: crumb.FolderId});
			}
			else{
				//folder I own
				this.state.go('content.myFiles.folder',{folderID: crumb.FolderId});
			}
			return;
		}

		if(crumb.IsPrivate){
			//user personal library				
			this.state.go('content.myFiles.home');
			return;
		}

		this.state.go('content.shared.library',{libraryID: crumb.LibraryId});
	}

	public searchItemSelected(item) {
		if (this.mobileSearchEnabled) {
			this.mobileSearchEnabled = false;
		}
		
		if (item.FolderId) {
			this.sbTrackingService.trackClick('Basic search result found', 'auto complete');
			this.state.go('content.myFiles.folder', { 'folderID': item.FolderId });
		}
		else if (item.DocumentId) {
			this.sbTrackingService.trackClick('Basic search result found', 'auto complete');
			this.state.go('content.myFiles.document', { 'docID': item.DocumentId });
		}
		else {
			// show all search results
			this.state.go('content.myFiles.search', {
				'phrase':item
			});
		}
	}

	public showFeatureSlides() {
		this.featureSlides.show(true);
	};

	public showFullBreadcrumbs(ev) {
		if(this.breadcrumbs().length < 2){ return;}
		//remove the top crumb as it's already visible in the UI
		var crumbs = angular.copy(this.breadcrumbs());
		crumbs.pop();
		var position = this.$mdPanel.newPanelPosition()
			.relativeTo('.sb-app__breadcrumb_more_button')
			.addPanelPosition(this.$mdPanel.xPosition.ALIGN_START, this.$mdPanel.yPosition.BELOW);

		this.showBreadcrumbPanel(ev, position, crumbs);
	}

	public showMobileFullBreadcrumbs(ev) {
		var crumbs = angular.copy(this.breadcrumbs());
		var position = this.$mdPanel.newPanelPosition()
			.relativeTo('.sb-app__breadcrumbs_mobile')
			.addPanelPosition(this.$mdPanel.xPosition.ALIGN_START, this.$mdPanel.yPosition.BELOW);
		
		this.showBreadcrumbPanel(ev, position, crumbs);
	}

	public setBadgeAndTab(unreadLength:number) {
		// https://regex101.com/r/gOO0bp/1
		let noCountTitle = this.$window.document.title.replace(/^\[\d+(\+)?\] /, '');
		this.notificationDS.badgeCount = this.sbBadgeCountFilter(unreadLength);
		this.$window.document.title = unreadLength > 0 ? 
			`[${this.notificationDS.badgeCount}] ${noCountTitle}` : 
			noCountTitle;
	}

	/**
	 * @ngdoc method
	 * @name sbaApp#showQuickNotifications
	 * @methodOf sharebase-app.sbaApp
	 * @kind function
	 * 
	 * @description
	 * 	There are three scenarios that will happen with this function:
	 * 1) It will display only unread notifications if there are more than 7.
	 * 2) It will display all unread notifications and however many other read notifications that add up to a total of 8.
	 * 3) It will display 8 read notifications.
	 * In all of these, it will add functionality to navigate to the notifications view.
	 * 
	 * @param $mdMenu 
	 * @param $event 
	 */
	public showQuickNotifications($mdMenu, $event) {
		let notificationCount = this.notificationDS.badgeCount > QUICK_NOTIFY_COUNT ?  this.notificationDS.badgeCount : QUICK_NOTIFY_COUNT;
		this.notificationDS
			.load(notificationCount)
			.then(() => {
				$mdMenu.open($event);
				this.setBadgeAndTab(0);
			});
	}

	public toggleDetailsPanel() {
		if (this.$mdMedia('gt-sm')) {
			// show inline
			this.rightNavOpenInline = !this.rightNavOpenInline;
			this.updateInlineRightPanelState(this.rightNavOpenInline);
		} 
		else { 
			this.rightNavOpen = !this.rightNavOpen;
		}
	}

	public toggleLeftNav() {
		this.leftNavOpen = !this.leftNavOpen;
	}

	public updateInlineRightPanelState(isOpen) {
		this.localStorageService.setStoredValue('sba-right-nav-inline-open', isOpen);
		this.$scope.$broadcast('px-recalulate-auto-fit-virtual-repeat');
	}

	public userLogout(event) {
		if (this.sbPendingActionsService.unsavedChanges) {
			this.sbaLogoutDialogService.open(event)
				.then(() => {
					this.logout();
				})
		}
		else {
			this.logout();
		}
	}

	private documentDeleteHandler(parentFolder) {
		// To see more on why we are currently doing it this way, see comments on SBWEB-1241
		// See: https://jira.hylandqa.net/browse/SBWEB-1241
		if (this.$window.history.length === 1) {
			// redirect to root of app
			this.state.go('content.myFiles.home');
		} else {
			// See: https://github.com/angular/angular.js/issues/3887
			this.$timeout(() => this.$window.history.back(), 0);
		}
	}

	private logout() {
		this.pxProgressService.enqueue(
			this.authService.invalidateLogin()
				.then(logoutUri => {
					if(logoutUri){
						this.$window.location.assign(logoutUri);
					} else {
						this.state.go('login');
					}
				})
				.catch(() => {
					this.state.go('login');
				})
		);
	}

	private promptDesktopDownload(event:ng.IAngularEvent) {
		return this.sbDownloadDesktopDialog.open(event);
	}

	private showBreadcrumbPanel(event, position, crumbs) {
		let appCtrl = this;
		let appCtrlOpenBreadcrumb = this.openBreadcrumb;

		var config = {
			attachTo: angular.element(document.body),
			controller: function() {
				this.openBreadcrumb = appCtrlOpenBreadcrumb.bind(appCtrl);
			},
			controllerAs: 'vm',
			template: breadcrumbsTemplate,
			panelClass: 'sb-app__breadcrumbs-panel',
			position: position,
			locals: {
				'crumbs': crumbs.reverse()
			},
			openFrom: event,
			clickOutsideToClose: true,
			escapeToClose: true,
			focusOnOpen: false,
			zIndex: 61
		};

		this.$mdPanel.open(config);
	}
}

// override default menu item implementation
angular
	.module('sharebase.services')
	.decorator('sbMenuItemFactory', [
		'$delegate', 
		'$injector', 
		($delegate:MenuItemFactory, $injector:ng.auto.IInjectorService) => {
			let analyticsMenuItemFactory:AnalyticsMenuItemFactory = $injector.instantiate(AnalyticsMenuItemFactory);
			
			function factoryCreator(
				SBA_GET_REQUEST_RIGHTS_ENABLED:() => boolean,
				sbaDeferredPermissionMenuItemFactory:DeferredPermissionMenuItemFactory
			) {
				$delegate.create = (actionName:string, label:string, icon:string) => {
					let item:IMenuItem;
					if(SBA_GET_REQUEST_RIGHTS_ENABLED()){
						item = sbaDeferredPermissionMenuItemFactory.create(actionName, label, icon);
					}
					else {
						item = analyticsMenuItemFactory.create(actionName, label, icon);							
					}

					return item;
				};					

				return $delegate;
			}

			factoryCreator.$inject = [
				'SBA_GET_REQUEST_RIGHTS_ENABLED',
				'sbaDeferredPermissionMenuItemFactory'
			];

			return $injector.instantiate(<any>factoryCreator);
		}
	])

angular
	.module('util.toggle')
	.decorator('staticToggleService', [
		'$delegate', 
		'$injector', 
		($delegate:StaticToggleService, $injector:ng.auto.IInjectorService) => {
			const toggleServiceFactory = (storageToggleServce:StorageToggleService) => storageToggleServce;
			toggleServiceFactory.$inject = [
				'storageToggleService'
			];

			return $injector.instantiate(<any>toggleServiceFactory);
		}
	]);



// WEBPACK FOOTER //
// ./src/sharebase-app/components/_app/app.ts